const MG3P_BASE_ROLES = [
  'ROLE_MG3P_PORTFOLIO_VISUALIZAR',
  'ROLE_MG3P_PORTFOLIO_EDITAR',
  'ROLE_MG3P_SUBPORTFOLIO_VISUALIZAR',
  'ROLE_MG3P_PROGRAMAS_VISUALIZAR',
  'ROLE_MG3P_PROJETOS_VISUALIZAR',
  'ROLE_MG3P_DEMANDAS_VISUALIZAR',
  'ROLE_MG3P_AUDIT_INGEST',
  'ROLE_MG3P_AUDIT_VISUALIZAR',
] as const;

export type ComissoesMockProfileId =
  | 'chem'
  | 'subchem'
  | 'gabinete'
  | 'chefe-secao'
  | 'membro'
  | 'consultivo';

export type ComissoesMockProfile = {
  id: ComissoesMockProfileId;
  label: string;
  username: string;
  clearance: 'OSTENSIVO' | 'RESERVADO' | 'CONFIDENCIAL';
  roles: string[];
};

export const COMISSOES_MOCK_PROFILES: ComissoesMockProfile[] = [
  {
    id: 'chem',
    label: 'CHEM',
    username: 'chem.demo',
    clearance: 'CONFIDENCIAL',
    roles: [
      ...MG3P_BASE_ROLES,
      'ROLE_COMISSOES_VISUALIZAR',
      'ROLE_COMISSOES_INSTAURAR',
      'ROLE_COMISSOES_ENCERRAR',
      'ROLE_COMISSOES_DESIGNAR_MEMBROS',
      'ROLE_COMISSOES_GERAR_DEMANDA_MG3P',
      'ROLE_COMISSOES_DOCUMENTO_UPLOAD',
    ],
  },
  {
    id: 'subchem',
    label: 'SUBCHEM',
    username: 'subchem.demo',
    clearance: 'CONFIDENCIAL',
    roles: [
      ...MG3P_BASE_ROLES,
      'ROLE_COMISSOES_VISUALIZAR',
      'ROLE_COMISSOES_SUPERVISAR',
    ],
  },
  {
    id: 'gabinete',
    label: 'Gabinete EM',
    username: 'gabinete.demo',
    clearance: 'RESERVADO',
    roles: [
      ...MG3P_BASE_ROLES,
      'ROLE_COMISSOES_VISUALIZAR',
      'ROLE_COMISSOES_ADMINISTRAR',
      'ROLE_COMISSOES_DESIGNAR_MEMBROS',
      'ROLE_COMISSOES_DOCUMENTO_UPLOAD',
    ],
  },
  {
    id: 'chefe-secao',
    label: 'Chefe Seção PM-x',
    username: 'secao.demo',
    clearance: 'RESERVADO',
    roles: [
      ...MG3P_BASE_ROLES,
      'ROLE_COMISSOES_VISUALIZAR',
      'ROLE_COMISSOES_SECAO_RECEBER',
      'ROLE_COMISSOES_SECAO_PARECER',
    ],
  },
  {
    id: 'membro',
    label: 'Membro comissão',
    username: 'membro.demo',
    clearance: 'OSTENSIVO',
    roles: [
      ...MG3P_BASE_ROLES,
      'ROLE_COMISSOES_VISUALIZAR',
      'ROLE_COMISSOES_MEMBRO_CONTRIBUIR',
      'ROLE_COMISSOES_DOCUMENTO_UPLOAD',
    ],
  },
  {
    id: 'consultivo',
    label: 'Consultivo (somente leitura)',
    username: 'consulta.demo',
    clearance: 'OSTENSIVO',
    roles: [...MG3P_BASE_ROLES, 'ROLE_COMISSOES_VISUALIZAR'],
  },
];

export const COMISSOES_MOCK_PROFILE_DEFAULT: ComissoesMockProfileId = 'chem';
